import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=169f8230"
import script from "./ItemCard.vue?vue&type=script&lang=ts"
export * from "./ItemCard.vue?vue&type=script&lang=ts"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=169f8230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports